/* Marcel Afters · LOOKBOOK SYSTEM script (5 Oct 2026). Vanilla, no library, deferred.
   - Hero Her/Him switch, card colourways (real variant images), quick-view sheet (bottom sheet on phones, drawer on desktop),
     PDP variant picker + add to bag through the theme cart (CartLinesUpdateEvent, same path as ma-sets10x.js),
     sticky add-to-bag bar, gallery counter, "Show more" pagination, recommendations loader.
   - Analytics: GA4-shaped dataLayer events (view_item_list, select_item, view_item, add_to_cart, begin_checkout,
     quiz_start, wholesale_apply) plus Shopify.analytics.publish for web pixels. No personal data.
   - Sheets are interruptible: drag tracks 1:1 from the grab offset, release projects momentum and settles with velocity. */
(function () {
  if (window.__maLb) return;
  window.__maLb = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var routes = (window.Theme && Theme.routes) || {};
  var reduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;
  function calm() { return !!(reduce && reduce.matches); }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var v = cents / 100;
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return '$' + (v % 1 ? v.toFixed(2) : v); }
  }
  function cleanTitle(t) { return String(t || '').replace(/^Marcel Afters\s+/, ''); }

  /* ---------- analytics ---------- */
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function track(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      if (payload && payload.ecommerce) window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(Object.assign({ event: event }, payload || {}));
    } catch (e) { /* ignore */ }
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ma_lb_' + event, payload || {}); } catch (e) { /* ignore */ }
  }
  window.maLbTrack = track;
  function itemFrom(card, i) {
    return { item_id: card.getAttribute('data-id'), item_name: cleanTitle(card.getAttribute('data-title')), price: Number(card.getAttribute('data-price')) || undefined,
      item_category: card.getAttribute('data-type') || undefined, index: Number(card.getAttribute('data-index')) || i || 1, item_list_name: card.getAttribute('data-list') || undefined };
  }
  var seenLists = new WeakSet();
  function armLists(ctx) {
    if (!('IntersectionObserver' in window)) return;
    var io = armLists.io || (armLists.io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var cards = $$('[data-lb-card]:not([data-lb-seen])', en.target);
        if (!cards.length) return;
        cards.forEach(function (c) { c.setAttribute('data-lb-seen', ''); });
        track('view_item_list', { ecommerce: { currency: CUR, item_list_name: en.target.getAttribute('data-lb-list') || 'lookbook', items: cards.slice(0, 40).map(itemFrom) } });
      });
    }, { threshold: 0.15 }));
    $$('[data-lb-list]', ctx).forEach(function (l) { if (!seenLists.has(l)) { seenLists.add(l); io.observe(l); } });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lb-select]');
    if (a) {
      var card = a.closest('[data-lb-card]');
      var item = card ? itemFrom(card) : { item_id: a.getAttribute('data-id'), item_name: cleanTitle(a.getAttribute('data-title')) };
      track('select_item', { ecommerce: { currency: CUR, item_list_name: item.item_list_name, items: [item] } });
    }
    if (e.target.closest && e.target.closest('[data-lb-quiz]')) track('quiz_start', { source: 'lookbook' });
    if (e.target.closest && e.target.closest('[data-lb-apply]')) track('wholesale_apply', { source: 'lookbook' });
    var co = e.target.closest && e.target.closest('a[href$="/checkout"], button[name="checkout"], [href*="/checkouts/"]');
    if (co) track('begin_checkout', { source: 'lookbook' });
  }, true);

  /* ---------- cart ---------- */
  function sectionIds() { return $$('cart-items-component').map(function (n) { return n.dataset && n.dataset.sectionId; }).filter(Boolean); }
  async function addLines(source, lines) {
    var mod = null, def = null;
    try { mod = await import('@shopify/events'); } catch (e) { mod = null; }
    if (mod && mod.CartLinesUpdateEvent) {
      try {
        def = mod.CartLinesUpdateEvent.createPromise();
        source.dispatchEvent(new mod.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: lines.map(function (l) { return { merchandiseId: String(l.id), quantity: l.quantity || 1 }; }), promise: def.promise }));
      } catch (e) { def = null; }
    }
    var body = { items: lines.map(function (l) { var it = { id: Number(l.id), quantity: l.quantity || 1 }; if (l.properties) it.properties = l.properties; return it; }) };
    var ids = sectionIds(); if (ids.length) body.sections = ids.join(',');
    var ok = false, json = null, cart = null;
    try {
      var res = await fetch(routes.cart_add_url || (ROOT + 'cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: JSON.stringify(body) });
      json = await res.json(); ok = res.ok && !json.status;
      try { var cr = await fetch((routes.cart_url || (ROOT + 'cart')) + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }); cart = await cr.json(); } catch (e2) { cart = null; }
    } catch (e) { ok = false; json = { description: 'Could not reach the bag. Try again.' }; }
    if (def) {
      if (cart) def.resolve({ cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'ma-lb', sourceId: 'ma-lb', itemCount: lines.length, sections: json && json.sections, didError: !ok } });
      else def.reject(new Error('cart unavailable'));
    } else if (ok) {
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) { /* ignore */ }
      $$('[data-cart-count], .cart-count-bubble span').forEach(function (n) { if (cart) n.textContent = cart.item_count; });
    }
    return { ok: ok, json: json };
  }

  /* ---------- variant model (shared by PDP and quick view) ---------- */
  function Picker(root, data, onChange) {
    this.root = root; this.data = data; this.onChange = onChange;
    this.groups = $$('[data-lb-opt]', root);
    var self = this;
    this.groups.forEach(function (g) { g.addEventListener('change', function () { self.sync(true); }); });
    this.sync(false);
  }
  Picker.prototype.selected = function () { return this.groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); };
  Picker.prototype.find = function (sel) {
    var vs = this.data.variants;
    for (var i = 0; i < vs.length; i++) { var ok = true; for (var j = 0; j < sel.length; j++) { if (sel[j] != null && vs[i].options[j] !== sel[j]) { ok = false; break; } } if (ok && sel.indexOf(null) === -1) return vs[i]; }
    return null;
  };
  Picker.prototype.sync = function (user) {
    var sel = this.selected(), self = this;
    /* availability of each value given the other selections (real variant data) */
    this.groups.forEach(function (g, gi) {
      $$('input', g).forEach(function (inp) {
        var test = sel.slice(); test[gi] = inp.value;
        var any = self.data.variants.some(function (v) { for (var j = 0; j < test.length; j++) { if (j !== gi && test[j] != null && v.options[j] !== test[j]) return false; } return v.options[gi] === inp.value && v.available; });
        inp.disabled = !any;
        if (!any && inp.checked && user) inp.checked = false;
      });
      var out = $('[data-lb-optval]', g); var c = $('input:checked', g); if (out) out.textContent = c ? c.value : '';
    });
    var v = this.find(this.selected());
    this.variant = v;
    if (this.onChange) this.onChange(v, user);
  };

  /* ---------- sheet ---------- */
  function project(v, d) { d = d || 0.998; return (v / 1000) * d / (1 - d); }
  var lastOpener = null;
  function openSheet(dlg, opener) {
    lastOpener = opener || document.activeElement;
    dlg.classList.remove('is-closing');
    if (!dlg.open) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
    armGrip(dlg);
  }
  function closeSheet(dlg) {
    if (!dlg.open || dlg.classList.contains('is-closing')) return;
    var done = function () { dlg.classList.remove('is-closing'); try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } var p = $('.lb-sheet__panel', dlg); if (p) p.style.translate = ''; if (lastOpener && lastOpener.focus) lastOpener.focus(); };
    if (calm()) return done();
    dlg.classList.add('is-closing');
    setTimeout(done, 270);
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-lb-close]');
    if (c) { var d = c.closest('dialog'); if (d) closeSheet(d); }
  });
  document.addEventListener('cancel', function (e) { if (e.target.matches && e.target.matches('.lb-sheet')) { e.preventDefault(); closeSheet(e.target); } }, true);
  function armGrip(dlg) {
    var grip = $('[data-lb-grip]', dlg), panel = $('.lb-sheet__panel', dlg);
    if (!grip || grip.__armed) return; grip.__armed = true;
    var y0 = 0, y = 0, hist = [], drag = false;
    grip.addEventListener('pointerdown', function (e) { drag = true; grip.setPointerCapture(e.pointerId); y0 = e.clientY - y; hist = [{ t: e.timeStamp, y: e.clientY }]; panel.style.animation = 'none'; panel.style.transition = 'none'; });
    grip.addEventListener('pointermove', function (e) {
      if (!drag) return; var d = e.clientY - y0;
      y = d < 0 ? -Math.sqrt(-d) * 2 : d; /* rubber band upwards */
      panel.style.translate = '0 ' + y + 'px'; hist.push({ t: e.timeStamp, y: e.clientY }); if (hist.length > 6) hist.shift();
    });
    function up() {
      if (!drag) return; drag = false;
      var a = hist[0], b = hist[hist.length - 1]; var v = b && a && b.t > a.t ? (b.y - a.y) / (b.t - a.t) * 1000 : 0;
      var end = y + project(v);
      var h = panel.offsetHeight;
      var shut = end > h * 0.45 || v > 900;
      var target = shut ? h : 0;
      var dur = calm() ? 1 : Math.min(420, Math.max(180, Math.abs(target - y) / Math.max(1, Math.abs(v)) * 1000));
      var anim = panel.animate([{ translate: '0 ' + y + 'px' }, { translate: '0 ' + target + 'px' }], { duration: dur, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' });
      anim.onfinish = function () { anim.cancel(); panel.style.animation = ''; panel.style.transition = ''; y = 0; if (shut) { panel.style.translate = '0 ' + h + 'px'; try { dlg.close(); } catch (e) { /* */ } panel.style.translate = ''; if (lastOpener && lastOpener.focus) lastOpener.focus(); } else { panel.style.translate = ''; } };
    }
    grip.addEventListener('pointerup', up); grip.addEventListener('pointercancel', up);
  }

  /* ---------- quick view ---------- */
  var qv = null;
  function qvShell() {
    if (qv) return qv;
    qv = document.createElement('dialog');
    qv.className = 'ma-lb lb-sheet'; qv.setAttribute('aria-labelledby', 'lb-qv-t');
    qv.innerHTML = '<button type="button" class="lb-sheet__scrim" data-lb-close tabindex="-1" aria-hidden="true"></button>' +
      '<div class="lb-sheet__panel"><div class="lb-sheet__grip" data-lb-grip aria-hidden="true"></div>' +
      '<div class="lb-sheet__hd"><p>Quick view</p><button type="button" class="lb-x" data-lb-close aria-label="Close"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.4"/></svg></button></div>' +
      '<div class="lb-sheet__bd" data-lb-qv-bd><p class="lb-sheet__live">Loading…</p></div>' +
      '<div class="lb-sheet__ft"><button type="button" class="lb-btn" data-lb-qv-add>Add to bag</button><a class="lb-link" data-lb-qv-pdp href="#" style="justify-content:center">Full details <svg class="ma-ico ma-ico--arr" width="18" height="10" viewBox="0 0 18 10" fill="none" stroke="currentColor" stroke-width="1.1" aria-hidden="true" focusable="false"><path d="M0 5h16M12.5 1.5 16 5l-3.5 3.5"/></svg></a></div></div>';
    document.body.appendChild(qv);
    return qv;
  }
  async function openQuick(btn) {
    var handle = btn.getAttribute('data-lb-qv');
    if (btn.getAttribute('data-mode') === 'ws' && window.MA_LB_WS) { window.MA_LB_WS.open(handle, btn); return; }
    var d = qvShell(); var bd = $('[data-lb-qv-bd]', d), add = $('[data-lb-qv-add]', d), pdp = $('[data-lb-qv-pdp]', d);
    bd.innerHTML = '<p class="lb-sheet__live" role="status">Loading…</p>'; add.disabled = false; add.textContent = 'Add to bag';
    openSheet(d, btn);
    var card = btn.closest('[data-lb-card]');
    if (card) track('select_item', { ecommerce: { currency: CUR, item_list_name: card.getAttribute('data-list'), items: [itemFrom(card)] } });
    var p;
    try { var r = await fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } }); p = await r.json(); }
    catch (e) { bd.innerHTML = '<p class="lb-sheet__live" data-tone="err" role="alert">This style could not load. <a href="' + ROOT + 'products/' + esc(handle) + '">Open the product page</a>.</p>'; return; }
    pdp.href = p.url || (ROOT + 'products/' + handle);
    var imgs = (p.media || []).filter(function (m) { return m.preview_image && !/vendor-ref/i.test(m.preview_image.src || ''); }).slice(0, 6);
    var html = '<div class="lb-sheet__strip">' + imgs.map(function (m, i) { var src = m.preview_image.src; var u = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=720'; return '<img src="' + esc(u) + '" alt="' + (i ? '' : esc(cleanTitle(p.title))) + '" width="720" height="900" loading="' + (i < 2 ? 'eager' : 'lazy') + '">'; }).join('') + '</div>';
    html += '<h2 class="lb-sheet__t" id="lb-qv-t">' + esc(cleanTitle(p.title)) + '</h2><p class="lb-sheet__p" data-lb-qv-price>' + money(p.price) + '</p>';
    var shoe = /shoe/i.test(p.type || '') || (p.tags || []).indexOf('footwear') > -1;
    var firstAvail = (p.variants || []).filter(function (v) { return v.available; })[0] || p.variants[0];
    (p.options || []).forEach(function (o, oi) {
      var isSize = /size/i.test(o.name);
      var vals = o.values || [];
      html += '<fieldset class="lb-opt" data-lb-opt="' + oi + '"><legend><span>' + esc(o.name) + (isSize && shoe ? ' (EU)' : '') + ': <span data-lb-optval></span></span>' + (isSize ? '<a href="' + ROOT + 'pages/size-and-fit" target="_blank" rel="noopener">Size help</a>' : '') + '</legend><div class="' + (isSize ? 'lb-sizes' : 'lb-opt__row') + '">' +
        vals.map(function (v) { var only = vals.length === 1; return '<label class="lb-pill"><input type="radio" name="lb-qv-' + oi + '" value="' + esc(v) + '"' + ((!isSize || only) && v === (firstAvail && firstAvail.options[oi]) ? ' checked' : '') + '><span>' + esc(v) + '</span></label>'; }).join('') + '</div></fieldset>';
    });
    html += '<p class="lb-sheet__live" role="status" aria-live="polite" data-lb-qv-live></p>';
    bd.innerHTML = html;
    /* prefer the first available colour */
    var picker = new Picker(bd, { variants: p.variants.map(function (v) { return { id: v.id, options: v.options, available: v.available, price: v.price, compare: v.compare_at_price || 0 }; }) }, function (v) {
      var live = $('[data-lb-qv-live]', bd);
      if (v) { $('[data-lb-qv-price]', bd).textContent = money(v.price); add.disabled = !v.available; add.textContent = v.available ? 'Add to bag' : 'Sold out'; live.textContent = ''; }
      else { add.disabled = false; add.textContent = 'Add to bag'; }
    });
    add.onclick = async function () {
      var v = picker.variant;
      if (!v) { /* point to the missing choice instead of a dead button */
        var g = $$('[data-lb-opt]', bd).filter(function (x) { return !$('input:checked', x); })[0];
        var live0 = $('[data-lb-qv-live]', bd); live0.removeAttribute('data-tone');
        live0.textContent = 'Choose a ' + (g ? $('legend span', g).textContent.split(':')[0].replace(/\s*\(EU\)/, '').toLowerCase() : 'size') + ' first.';
        if (g) { var f0 = $('input:not(:disabled)', g); if (f0) f0.focus(); }
        return;
      }
      if (!v.available) return;
      add.disabled = true; add.textContent = 'Adding…';
      var res = await addLines(add, [{ id: v.id, quantity: 1 }]);
      var live = $('[data-lb-qv-live]', bd);
      if (res.ok) {
        track('add_to_cart', { ecommerce: { currency: CUR, value: v.price / 100, items: [{ item_id: String(p.id), item_name: cleanTitle(p.title), item_variant: (v.options || []).join(' / '), price: v.price / 100, quantity: 1 }] } });
        live.setAttribute('data-tone', 'ok'); live.textContent = 'Added to your bag.'; add.textContent = 'Added';
        setTimeout(function () { closeSheet(d); }, calm() ? 600 : 900);
      } else {
        live.setAttribute('data-tone', 'err'); live.textContent = (res.json && (res.json.description || res.json.message)) || 'Could not add. Try again.'; add.disabled = false; add.textContent = 'Add to bag';
      }
    };
  }
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-lb-qv]'); if (b) { e.preventDefault(); openQuick(b); } });

  /* ---------- cards: colourways ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lb-colour]'); if (!b) return;
    var card = b.closest('[data-lb-card]'); var img = card && $('img.lb-card__img', card); if (!img) return;
    if (!img.dataset.orig) { img.dataset.orig = img.currentSrc || img.src; img.dataset.origSet = img.getAttribute('srcset') || ''; }
    var first = $('[data-lb-colour]', card) === b;
    if (first) { img.src = img.dataset.orig; if (img.dataset.origSet) img.setAttribute('srcset', img.dataset.origSet); }
    else { img.removeAttribute('srcset'); img.src = b.getAttribute('data-src'); }
    $$('[data-lb-colour]', card).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
  });

  /* ---------- hero switch ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lb-switch]'); if (!b) return;
    var cover = b.closest('.lb-cover'); if (!cover) return;
    cover.setAttribute('data-active', b.getAttribute('data-lb-switch'));
    $$('[data-lb-switch]', cover).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
  });

  /* ---------- PDP ---------- */
  function armPdp(root) {
    if (root.__lb) return; root.__lb = true;
    var data; try { data = JSON.parse($('[data-lb-product]', root).textContent); } catch (e) { return; }
    var form = $('[data-lb-form]', root), idIn = $('[data-lb-id]', root), btn = $('[data-lb-add]', root), status = $('[data-lb-status]', root), price = $('[data-lb-price]', root);
    var stick = $('[data-lb-stick]', root), stickBtn = $('[data-lb-stick-btn]', root), stickSub = $('[data-lb-stick-sub]', root);
    if (idIn) idIn.disabled = false;
    var hasSize = data.options.some(function (o) { return /size/i.test(o); });
    /* Do not preselect a size: the shopper chooses it (avoids wrong-size orders). Colour stays preselected. */
    $$('[data-lb-opt]', root).forEach(function (g, gi) {
      if (/size/i.test(data.options[gi] || '') && $$('input', g).length > 1) { var c = $('input:checked', g); if (c && !/[?&]variant=/.test(location.search)) c.checked = false; }
    });
    var picker = new Picker(form, data, function (v, user) {
      if (v) {
        idIn.value = v.id;
        price.innerHTML = (v.compare > v.price ? '<s>' + money(v.compare) + '</s>' : '') + money(v.price);
        btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out';
        if (stickSub) stickSub.textContent = money(v.price) + (v.options ? ' · ' + v.options.join(' / ') : '');
        if (stickBtn) stickBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
        if (user && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
        status.textContent = '';
      } else {
        btn.disabled = false; btn.textContent = 'Add to bag';
        if (stickBtn) stickBtn.textContent = hasSize ? 'Choose size' : 'Add to bag';
      }
    });
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      var v = picker.variant;
      if (!v) {
        var g = $$('[data-lb-opt]', form).filter(function (x) { return !$('input:checked', x); })[0];
        status.textContent = 'Choose a ' + (g ? $('legend span', g).textContent.split(':')[0].toLowerCase() : 'size') + ' first.';
        if (g) { var first = $('input:not(:disabled)', g); if (first) first.focus(); }
        return;
      }
      if (!v.available) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      var res = await addLines(btn, [{ id: v.id, quantity: 1 }]);
      if (res.ok) {
        track('add_to_cart', { ecommerce: { currency: CUR, value: v.price / 100, items: [{ item_id: String(data.id), item_name: cleanTitle(data.title), item_variant: v.options.join(' / '), price: v.price / 100, quantity: 1 }] } });
        status.textContent = 'Added to your bag.'; btn.textContent = 'Added';
        setTimeout(function () { btn.disabled = false; btn.textContent = 'Add to bag'; }, 1600);
      } else {
        status.textContent = (res.json && (res.json.description || res.json.message)) || 'Could not add. Try again.';
        btn.disabled = false; btn.textContent = 'Add to bag';
      }
    });
    /* view_item */
    track('view_item', { ecommerce: { currency: CUR, value: Number(root.getAttribute('data-price')) || undefined, items: [{ item_id: String(data.id), item_name: cleanTitle(data.title), item_category: data.type, price: Number(root.getAttribute('data-price')) || undefined }] } });
    /* sticky bar: after the main button scrolls away, until the footer */
    if (stick && 'IntersectionObserver' in window) {
      /* Show the bar whenever the buy block (options + Add to bag) is off screen: on load when it sits below the fold,
         and again once it has scrolled away. Hidden while any of it is visible, so it never covers the size grid. */
      var on = false;
      function setStick(v) { on = v; stick.classList.toggle('is-on', v); stick.setAttribute('aria-hidden', v ? 'false' : 'true'); stickBtn.tabIndex = v ? 0 : -1; }
      setStick(false);
      new IntersectionObserver(function (es) { setStick(!es[0].isIntersecting); }, { threshold: 0 }).observe(btn); /* bar until Add to bag itself is on screen */
      stickBtn.addEventListener('click', function () {
        if (picker.variant && picker.variant.available) { form.requestSubmit ? form.requestSubmit() : btn.click(); return; }
        var g = $$('[data-lb-opt]', form).filter(function (x) { return !$('input:checked', x); })[0] || $('[data-lb-opt]', form);
        g.scrollIntoView({ behavior: calm() ? 'auto' : 'smooth', block: 'center' });
        var first = $('input:not(:disabled)', g); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, calm() ? 0 : 450);
      });
    }
    /* size help opens the fit accordion */
    var help = $('[data-lb-sizehelp]', root);
    if (help) help.addEventListener('click', function (e) { var t = document.getElementById(help.getAttribute('href').slice(1)); if (t) { e.preventDefault(); t.open = true; t.scrollIntoView({ behavior: calm() ? 'auto' : 'smooth', block: 'start' }); $('summary', t).focus({ preventScroll: true }); } });
    /* gallery counter */
    var gal = $('[data-lb-gal]', root), gi = $('[data-lb-gal-i]', root);
    if (gal && gi) { var t = 0; gal.addEventListener('scroll', function () { if (t) return; t = requestAnimationFrame(function () { t = 0; gi.textContent = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth)) + 1; }); }, { passive: true }); }
  }

  /* ---------- grid: show more + sort ---------- */
  function armGrid(sec) {
    if (sec.__lb) return; sec.__lb = true;
    var sort = $('[data-lb-sort] select', sec);
    if (sort) sort.addEventListener('change', function () { sort.form.submit(); });
    sec.addEventListener('click', async function (e) {
      var more = e.target.closest && e.target.closest('[data-lb-more]'); if (!more) return;
      e.preventDefault(); if (more.getAttribute('aria-busy') === 'true') return;
      more.setAttribute('aria-busy', 'true'); var label = more.textContent; more.textContent = 'Loading…';
      try {
        var res = await fetch(more.href.split('#')[0], { headers: { Accept: 'text/html' } });
        var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        var src = doc.querySelector('[data-lb-grid] [data-lb-items]'), list = $('[data-lb-items]', sec);
        var added = src ? [].slice.call(src.children) : [];
        added.forEach(function (li) { list.appendChild(document.importNode(li, true)); });
        var nextMore = doc.querySelector('[data-lb-grid] [data-lb-more]'), shown = doc.querySelector('[data-lb-grid] [data-lb-shown]');
        if (shown) $('[data-lb-shown]', sec).textContent = shown.textContent;
        if (nextMore) { more.href = nextMore.href; more.textContent = label; more.removeAttribute('aria-busy'); } else { more.remove(); }
        var firstNew = added[0] && list.children[list.children.length - added.length];
        var a = firstNew && $('a', firstNew); if (a) a.focus({ preventScroll: true });
        if (added.length) {
          var cards = added.map(function (li, i) { return $('[data-lb-card]', list.children[list.children.length - added.length + i]); }).filter(Boolean);
          cards.forEach(function (c) { c.setAttribute('data-lb-seen', ''); });
          track('view_item_list', { ecommerce: { currency: CUR, item_list_name: sec.getAttribute('data-lb-list'), items: cards.map(itemFrom) } });
        }
      } catch (err) { location.href = more.href; }
    });
  }

  /* ---------- recommendations ---------- */
  async function armRecs(el) {
    if (el.__lb) return; el.__lb = true;
    var wrap = el.closest('[data-lb-recs-wrap]');
    async function load(url) { try { var r = await fetch(url); var t = await r.text(); var doc = new DOMParser().parseFromString(t, 'text/html'); return doc.querySelector('.lb-rail') ? doc.querySelector('.lb-shell') : null; } catch (e) { return null; } }
    var shell = await load(el.getAttribute('data-lb-recs'));
    if (!shell && el.getAttribute('data-lb-recs-fallback')) shell = await load(el.getAttribute('data-lb-recs-fallback'));
    if (!shell) { if (wrap) wrap.hidden = true; return; }
    el.replaceWith.apply(el, [].slice.call(shell.childNodes).map(function (n) { return document.importNode(n, true); }));
    armLists(wrap);
  }

  function start() {
    $$('[data-lb-pdp]').forEach(armPdp);
    $$('[data-lb-grid]').forEach(armGrid);
    $$('[data-lb-recs]').forEach(armRecs);
    armLists(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.MA_LB = { openSheet: openSheet, closeSheet: closeSheet, addLines: addLines, track: track, money: money, Picker: Picker };
})();
